const Pregled = function(DS) {
    return DS.defineResource({
        name: 'Pregled',
        endpoint: '/pregledi',
    });
};


Pregled.$inject = ['DS'];

export {Pregled};



// WEBPACK FOOTER //
// ./app/models/pregled.js